import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import i18n from '../../Shared/Translation/i18n';
import { ApiUrl, AppPages } from '../../project/Defines.js';
import { Project } from '~/project/Project';
import { dispatchCustomEvent, EVENT_NAME } from '../../project/utilities';
import DetailView from '../../Shared/DetailView';
import useDetail from '../../Shared/useDetail';
import InputCont from '../../Shared/Form/InputCont';

/**
 * ...
 * @exports SalesNetworkDetails
 */
export default function SalesNetworkDetails(props) {
    const { id } = useParams();
    const { windowKey, data } = props;
    const listUpdateEvent = EVENT_NAME.SALES_NETWORK_LIST_UPDATE;

    const { isNew, dataItem, setDataItem, updateData, hasChanges, closePopup, onDetailDelete, detailRef, onChangeData, validation } = useDetail({
        data: data || { ID: id !== "create" ? id : 0 },
        windowKey,
        updateUrl: ApiUrl.SalesNetworkUpdate,
        dataLoadUrl: ApiUrl.SalesNetworkLoad,
        deleteUrl: ApiUrl.SalesNetworkDelete,
        onLoadData: (response, _setDataItem) => {
            _setDataItem({...response, brands: JSON.parse(`[${response.brands}]`)})
        },
        nameField: 'name',
        backPage: AppPages.SalesNetwork,
        listUpdateEvent,
        detailUrl: Project.getPageUrl(AppPages.SalesNetworkDetails),
        // changingValidation: true,
        validationFields: ['name', 'code', 'ssoId', 'brands']
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
        }

        dispatchCustomEvent(listUpdateEvent, { action: 'update' });
        closePopup();
    }, [setDataItem, closePopup, detailRef, listUpdateEvent]);

    const onChangeAquamed = (e) => {
        let brands = dataItem.brands;

        if(e.target.checked && dataItem?.brands?.length > 1) {
            brands =  dataItem.brands[0] 
        }

        setDataItem({
            ...dataItem,
            brands: brands,
            aquamede: e.target.checked
        });
    }

    const typeOfBrandSelect = dataItem && dataItem.thercodim && !dataItem.aquamede ? 'multiselect' : 'select';

    return (<>
        {dataItem && <DetailView
            hasChanges={hasChanges}
            backUrl={Project.getPageUrl(AppPages.SalesNetwork)}
            title={isNew ? i18n('text.sales_networks') : dataItem.name}
        >
            <view >
                <form>
                    <div className='form_container'>
                        <div className='section_group'>
                            <div className='sections '>
                                <InputCont label="text.name"
                                    inputProps={{ validation, name: 'name', value: dataItem.name, onChange: onChangeData, maxLength: 255 }} />

                                <InputCont label="text.code"
                                    inputProps={{ validation, name: 'code', value: dataItem.code, onChange: onChangeData, disabled: !isNew, maxLength: 50 }} />

                                <InputCont label="text.brand"
                                    inputProps={{
                                        validation,
                                        name: 'brands',
                                        type: typeOfBrandSelect,
                                        value: dataItem.brands.length === 0 ? '' : dataItem.brands,
                                        valuelist: 'brands',
                                        onChange: e => onChangeData({ target: { name: 'brands', value: e } }),
                                        disableCach: true,
                                        autoSelectFirst: true
                                    }} /> 

                                <InputCont label="text.sso"
                                    inputProps={{
                                        validation,
                                        name: 'ssoId',
                                        type: 'select',
                                        value: dataItem.ssoId === 0 ? '' : dataItem.ssoId,
                                        valuelist: 'sso',
                                        onChange: e => onChangeData({ target: { name: 'ssoId', value: e } })
                                    }} /> 

                                <InputCont label="text.cookiebot"
                                    inputProps={{ validation, name: 'cookiebot', value: dataItem.cookiebot, onChange: onChangeData, maxLength: 36 }} />
                            </div>
                            <div className='sections '>
                                <cont>
                                    <InputCont
                                        label={`text.aquamede`}
                                        inputProps={{
                                            type: 'checkbox',
                                            name: "aquamede",
                                            value: dataItem.aquamede,
                                            onChange: onChangeAquamed,
                                        }}
                                    />
                                </cont>
                                <cont>
                                    <InputCont
                                        label={`text.thercodim`}
                                        inputProps={{
                                            type: 'checkbox',
                                            name: "thercodim",
                                            value: dataItem.thercodim,
                                            onChange: onChangeData,
                                        }}
                                    />
                                </cont>
                                <InputCont label="text.urlAquamede"
                                    inputProps={{ validation, name: 'urlAquamede', value: dataItem.urlAquamede, onChange: onChangeData }} />
                                <InputCont label="text.urlThercodim"
                                    inputProps={{ validation, name: 'urlThercodim', value: dataItem.urlThercodim, onChange: onChangeData}} />
                                <InputCont label="text.code_localisation"
                                    inputProps={{name: 'code_localisation', value: dataItem.code_localisation, onChange: onChangeData, maxLength: 50 }} />
                                <InputCont label="text.code_reseau_commercial"
                                    inputProps={{name: 'code_reseau_commercial', value: dataItem.code_reseau_commercial, onChange: onChangeData, maxLength: 50 }} />
                            </div>
                        </div>
                    </div>
                    <toolbar>
                        <wrap>
                            <action right=''>
                                <div onClick={(e) => updateData(updateSuccessCallback)} className={hasChanges ? ' button primary' : 'button'}><icon>save</icon>{i18n('text.save')}</div>
                                {dataItem.ID > 0 && !dataItem.IsCurrentUser &&
                                    <div className='button' onClick={(e) => {
                                        onDetailDelete(dataItem)
                                    }}>
                                        <icon>delete</icon>{i18n('text.delete')}
                                    </div>}
                            </action>
                        </wrap>
                    </toolbar>
                </form>
            </view>
        </DetailView>}
    </>);
}
